"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _luxon = require("luxon");

var DateTimeHelper = {
  /*
   * `changeTz` takes `date` and returns a new date that:
   * 1) Doesn't change the year, month, and date of month of `date`.
   * 2) But does change the time zone to the `timeZone` passed in.
   * 3) And has the hours, minutes, and seconds as 00:00:00.
   */
  changeTz: function changeTz(luxonDate, timeZone) {
    var year = luxonDate.year;
    var month = luxonDate.month;
    var dateOfMonth = luxonDate.day;
    return _luxon.DateTime.fromObject({
      year: year,
      month: month,
      day: dateOfMonth,
      zone: timeZone
    });
  }
};
var _default = DateTimeHelper;
exports["default"] = _default;